export class palletTypeDto {
    palletType:string;
}